// VERFICAR PARA EXCLUIR ESTE ARQUIVO

import React from 'react';
import urlBase from '../../url-base';
import axios from 'axios';
import {
  Alert, Container, Row, Col, Label, FormGroup, Input, Button
} from 'reactstrap';

//import MenuNew from '../MenuNew';
//import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';
//import Contact from '../HomePageNew/Contact';
import Dialog from 'material-ui/Dialog';
import { Link } from 'react-router';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import '../../assets/css/clinicas.css';

import { FaPhoneVolume, FaMapMarkerAlt, FaRegBuilding, FaRegEdit } from "react-icons/fa";

//import pdfRedeCredenciada from '../../components/relatorio/credenciado';


/* Melhoria de performance
 import { FaPhoneVolume } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaRegBuilding } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa"; */
//import { FaRegUserCircle } from "react-icons/fa";




class AccreditedNetworkScreen extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      listOfStates:[],
      accreditedNetwork     : [],
      listOfMunicipalities  : [],
      listOfDistrict        : [],
      openMap               : false,
      googleUrl             : "",
      dataClinic            : {},

      valueOption: -1,
      listSpecialties: [],
      estado:'',
      idCidade: '',
      idEstado: '',
      especialidade: btoa('none'),
      tipo: btoa('bairro'),
      idBairro: btoa('none')
    };
    this.styles = {

    };
    this.downloadPDF = this.downloadPDF.bind(this);
    this.openPDF = this.openPDF.bind(this);

  }
  /*
  downloadPDF()  {
    let state = this.state;
    pdfRedeCredenciada(state.accreditedNetwork, "download");
  }
  openPDF()  {
    let state = this.state;
    pdfRedeCredenciada(state.accreditedNetwork,"visualizar");
  }
*/
  componentDidMount() {

    // Busca os estados
    axios.get(urlBase.loopBack+'APIS4s/UFs')
    .then((result) => {
      let state = this.state;

      for (var i = result.data.length - 1; i >= 0; --i) {
        var atuacao = ["PB", "PE", "RN","MA"];
        let sigla = atuacao.indexOf(result.data[i].Sigla);
        if (sigla == '-1') {
          result.data.splice(i, 1);
        }
      }

      state.listOfStates = result.data;
     
      this.setState(state);
      //document.getElementById('loading_i_select_states').style.display = 'none';
    })
    .catch(function (erro) {
      console.log(erro);
    });

    // Rede credenciada----------
    if (sessionStorage.getItem("id_state_rede") != null &&
        sessionStorage.getItem("id_city_rede") != null &&
        sessionStorage.getItem("id_district_rede") != null &&
        sessionStorage.getItem("id_state_rede").length >= 0 &&
        sessionStorage.getItem("id_city_rede").length >= 0 &&
        sessionStorage.getItem("id_district_rede").length >= 0) {

      this.findAccreditedNetwork();
    }
  }

  // Busca cidades
  findCity(uf=null, city=null) {
    let	url = urlBase.loopBack+'APIS4s/Municipios';
    let idState = '';

    let state = this.state;
    state.valueOption = -1;
    this.setState(state);

    document.getElementById('col_i_credenc_options').style.display = 'none';
    document.getElementById('i_credenc_city').value = -1;

    if (uf != null)
      idState = parseInt(uf);
    else
      idState = parseInt(document.getElementById('i_select_states').value);

    
    if (idState != -1) {
      let	dataPost = {
        idUF: idState
      };
      document.getElementById('loading_i_credenc_city').style.display = 'block';

      axios.post(url, dataPost)
      .then((result) => {
        let state = this.state;
        state.listOfMunicipalities = result.data;
        this.setState(state);
        document.getElementById('loading_i_credenc_city').style.display = 'none';
        document.getElementById('col_i_credenc_city').style.display = 'block';

        if (city != null)
          document.getElementById('i_credenc_city').value = city;

      })
      .catch(function (erro) {
        alert(erro);
      });
    }
    else {
      document.getElementById('col_i_credenc_city').style.display = 'none';
      document.getElementById('col_i_credenc_district').style.display = 'none';
    }
    this.findAccreditedNetwork();
  }

  //Modal map---------
  onOpenModalMap(index) {
    let googleUrlBegin = "https://maps.google.com/maps?saddr=",
        googleUrlEnd  = "&output=embed",
        address =  this.state.accreditedNetwork[index].Endereco,
        state = this.state;
    
    state.dataClinic = this.state.accreditedNetwork[index];
    state.googleUrl = googleUrlBegin+address+googleUrlEnd;
    state.openMap = true;
    this.setState(state);
  }

  onCloseModalMap() {
    this.setState({ openMap: false });
  }

  // Busca rede credenciada
  findAccreditedNetwork() {
    let url = urlBase.loopBack+'APIS4s/RedeAtendimento',
        uf = '',
        idCity = '',
        idDistrict = '';

    if (sessionStorage.getItem("id_state_rede") != null &&
        sessionStorage.getItem("id_city_rede") != null &&
        sessionStorage.getItem("id_district_rede") != null &&
        sessionStorage.getItem("id_state_rede").length >= 0 &&
        sessionStorage.getItem("id_city_rede").length >= 0 &&
        sessionStorage.getItem("id_district_rede").length >= 0) {

      uf = sessionStorage.getItem("id_state_rede");
      idCity = sessionStorage.getItem("id_city_rede");
      idDistrict = sessionStorage.getItem("id_district_rede");
    }
    else {
      uf = document.getElementById('i_select_states').value;
      idCity = document.getElementById('i_credenc_city').value;

      if (document.getElementById('i_credenc_district') != null)
        idDistrict = document.getElementById('i_credenc_district').value;
    }

    let	dataPost = {
      uf         : uf,   
      idCity     : idCity,
      idDistrict : idDistrict,
    };
    this.state.estado = btoa(uf);
    this.state.idBairro = btoa(idDistrict);
    if (idDistrict==''){
      this.state.idBairro = btoa('none');
    }
    this.state.idCidade = btoa(idCity);

    if (document.getElementById('i_select_specialties') != null){
      dataPost.specialties = document.getElementById('i_select_specialties').value;
      this.state.tipo = btoa('especialidade');
      this.state.especialidade = btoa(dataPost.specialties);
      this.state.idEstado = btoa('none');
      //this.state.idCidade = 'none';
    }
      
    document.getElementById('loading_i_credenc_result').style.display = 'block';
    
    this.setState(this.state);

    axios.post(url, dataPost)
    .then((result) => {
      let state = this.state;

      if (result.data.length == 0)
        state.accreditedNetwork = 'empty';
      else
        state.accreditedNetwork = result.data;

      this.setState(state);
      document.getElementById('loading_i_credenc_result').style.display = 'none';

      if (sessionStorage.getItem("id_state_rede") != null &&
        sessionStorage.getItem("id_city_rede") != null &&
        sessionStorage.getItem("id_district_rede") != null &&
        sessionStorage.getItem("id_state_rede").length >= 0 &&
        sessionStorage.getItem("id_city_rede").length >= 0 &&
        sessionStorage.getItem("id_district_rede").length >= 0) {

        document.getElementById('i_select_states').value = uf;
        this.findCity(uf, idCity);
        this.findDistrict(idCity, idDistrict);
      }
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

removeDuplicates(array, key) {
  return array.reduce((accumulator, element) => {
    if (!accumulator.find(el => el[key] == element[key])) {
      accumulator.push(element);
    }
    return accumulator;
  }, []);
}

  // Busca bairro
  findDistrict(city=null, district=null) {
    let	url = urlBase.loopBack+'APIS4s/BairrosAtendidos';
    let idCity = '';

    if (city != null)
      idCity = parseInt(city);
    else {
      idCity = parseInt(document.getElementById('i_credenc_city').value);
    }

    if (idCity != -1) {
      let	dataPost = {
        idCity: idCity//id do bairro
      };

      document.getElementById('loading_i_credenc_district').style.display = 'block';
  
      axios.post(url, dataPost)
      .then((result) => {
        let state = this.state;                      
        let districtFiltered = result.data.filter(function (obj) {
          return obj.Nome !== 'JARDIM CIDADE UNIVERSATARIA' && obj.Nome !== 'PLANALTO BOA ESPERANCA' && obj.Nome !== 'VALENTINA FIGUEIREDO' ;
        });
        state.listOfDistrict = this.removeDuplicates(districtFiltered,'Nome');         
        this.setState(state);
        document.getElementById('loading_i_credenc_district').style.display = 'none';
        document.getElementById('col_i_credenc_district').style.display = 'block';
  
        if (district != null)
          document.getElementById('i_credenc_district').value = district;
      })
      .catch(function (erro) {
        alert(erro);
      });
    }
    else
      document.getElementById('col_i_credenc_district').style.display = 'none';
  }

  // Traça a rota no mapa ate a rede credenciada
  findRouterMap(event){
    event.preventDefault();
    let  googleUrlOrigin = this.state.dataClinic.Endereco;
    let  googleUrlDestiny  = document.getElementById('originClient').value;
    let  state = this.state;

    state.googleUrl = "https://maps.google.com/maps?saddr="+googleUrlOrigin+ "&daddr=" +googleUrlDestiny+ "&output=embed";
    this.setState(state); 
  }

  optionsChange() {
    let opition = document.getElementById('i_select_options').value;
    let state = this.state;
    state.valueOption = opition;
    state.accreditedNetwork = null;
    this.setState(state);

    if (opition == 1) //Bairros
      this.findDistrict(null, null);
    else if (opition == 2) // Especialidades
      this.getSpecialties();
    this.findAccreditedNetwork();
  }

  getSpecialties() {
    let state = this.state;
    state.listSpecialties = 'loading';
    this.setState(state);

    axios.post(urlBase.loopBack+'APIS4s/Especialidades')
      .then((result) => {
        let state = this.state;
        for (let i = 0; i < result.data.length; i++) {
          let reg = result.data[i];
          if (reg.Nome == 'ATENDIMENTO ESPECIAL') {
               result.data[i].Nome = 'ATENDIMENTO PESSOAS ESPECIAIS';
          }
          /*if (reg.Nome == 'CIRURGIA') {
            result.data[i].Nome = 'CIRURGIA (EXTRAÇÃO SIMPLES)';
          } */    
          if (reg.Nome == 'CLINICO GERAL (DENTÍSTICA)') {
            result.data[i].Nome = ' CLÍNICO GERAL (EXTRAÇÃO SIMPLES, RESTAURAÇÃO e LIMPEZA SIMPLES)';
          } 
          if (reg.Nome == 'ENDODONTIA') {
            result.data[i].Nome = 'ENDODONTIA (TRAT. CANAL)';
          }    
          if (reg.Nome == 'ODONTOPEDIATRIA') {
            result.data[i].Nome = 'ODONTOPEDIATRIA (CRIANÇAS)';
          }      
          if (reg.Nome == 'PERIODONTIA') {
            result.data[i].Nome = 'PERIODONTIA (TRAT. GENGIVAS)';
          } 
          if (reg.Nome == 'PRÓTESE DENTÁRIA') {
            result.data[i].Nome = 'PRÓTESE DENTÁRIA (COROAS)';
          }                                       
        }
       // let dadosArray = result.data
      //  dadosArray[0].Nome = 'ATENDIMENTO PESSOAS ESPECIAIS';
      //  dadosArray[1] = 'CIRURGIA (EXTRAÇÃO SIMPLES)';

        state.listSpecialties = result.data;
        this.setState(state);
      })
      .catch(function (erro) {
        alert(erro);
      });
  }

  specialtiesChange() {
    let	dataPost = {
      specialties : document.getElementById('i_select_specialties').value
    };

    axios.post(urlBase.loopBack+'APIS4s/RedeAtendimento', dataPost)
    .then((result) => {
      let state = this.state;

      if (result.data.length == 0)
        state.accreditedNetwork = 'empty';
      else
        state.accreditedNetwork = result.data;

      this.setState(state);
      document.getElementById('loading_i_credenc_result').style.display = 'none';
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  showOptions() { 
    if (document.getElementById('i_credenc_city').value == -1)
      document.getElementById('col_i_credenc_options').style.display = 'none';
    else
      document.getElementById('col_i_credenc_options').style.display = 'block';
    this.findAccreditedNetwork();
    if (document.getElementById('i_credenc_district') != null)
       this.findDistrict(null, null);

  }

  render() {

    const { openMap } = this.state;
    
    return (
      <div>
            {/* Retirar Menus 
            <MenuNew />        
            <NavbarDrop />
            */}
        <Container id="accredited_network">
          
                  {/* Botão Voltar para o home */}
                  <Row style={{marginLeft: 80}}>
                      <Col style={{marginTop:30}} xs="12" sm="12" md="8" lg="8" xl="8">
                          <Link href="https://institucional.planodentalcenter.com.br/">
                                  <Button
                                              className="button_voltar"
                                              type="submit"
                                            >
                                          ← Voltar para Home
                                  </Button>                            
                          </Link>
                      </Col> 
                  </Row>          
          <div className="accredited_network_img">
            <Row style={{marginRight: 0}}>
                       <Col style={{marginTop:30}} xs="12" sm="12" md="2" lg="2" xl="2">
                            {/* Imagens 1 */}
                            <div className="accredited_network_img_1"> </div> 
                        </Col>              

              <Col id="accredited_network_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                <h1>
                  Sua rede credenciada
                </h1>
                <p>
                  Encontre os dentistas mais próximo de você
                </p>

                <Row className="width_select">
                  <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <div className="acrylic_dentist choose_city_dentist" style={{width:'100%'}}>
                      <FormGroup className="arrow_dentist" style={{margin: 0, textAlign: 'center'}}>
                        <Input
                          type="select" style={{ backgroundColor: 'transparent !important', border: '0px !important' }} name="select" id="i_select_states"
                          onChange={this.findCity.bind(this, null, null)}>
                        
                          <option value={-1}>SELECIONE SEU ESTADO </option>
                          { 
                            this.state.listOfStates.map(item =>
                              <option key={item.Id} value={item.Id}>{item.Sigla}</option>
                            )
                          }
                        </Input>
                      </FormGroup>
                    </div>
                  </Col>
                </Row>

                <Row className="width_select">
                  <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <div>
                      <i id="loading_i_credenc_city"
                        style={{ display: 'none', width: 16, margin: '0 auto 8px auto'}}
                        className="fa fa-spinner fa-spin">
                        &nbsp;
                      </i>
                    </div>
                    <div id="col_i_credenc_city" style={{display: 'none'}}>
                      <div className="acrylic_dentist choose_city_dentist" style={{width:'100%'}}>
                        <FormGroup className="arrow_dentist" style={{margin:0, textAlign:'center'}}>
                          <Input
                            type="select" name="select" id="i_credenc_city"
                            onChange={this.showOptions.bind(this)}
                          >
                            <option value={-1}>SELECIONE SUA CIDADE</option>
                            { 
                              this.state.listOfMunicipalities.map((item, index) =>
                                document.getElementById('i_select_states').value == '14' ? (
                                  index < 8 ? (// Cidades mais importantes
                            <option key={index} value={item.Id}>{item.Nome}</option>
                                  ) : (// Restante das cidades
                                    index > 8 ? (
                            <option key={index} value={item.Id}>{item.Nome}</option>
                                    ) : (// Divisão
                            [<optgroup  label="----------">{''}</optgroup> ,
                             <option key={index} value={item.Id}>{item.Nome}</option> ]

                                    )
                                  )
                                ) : (// Outros estados
                            <option key={index} value={item.Id}>{item.Nome}</option>
                                )
                            )}
                          </Input>
                        </FormGroup>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="width_select">
                  <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <div 
                      id="col_i_credenc_options"
                      className="acrylic_dentist choose_city_dentist"
                      style={{width:'100%', display: 'none'}}>
                      <FormGroup className="arrow_dentist" style={{margin:0, textAlign:'center'}}>
                        <Input
                          type="select" name="select" id="i_select_options"
                          onChange={this.optionsChange.bind(this)}>
                          <option value={-1}>SELECIONE UMA OPÇÃO</option>
                          <option value={1}>PESQUISA POR BAIRRO</option>
                          <option value={2}>PESQUISA POR ESPECIALIDADES</option>
                          {/* <option value={3}>PESQUISA POR CLÍNICA</option>
                          <option value={4}>PESQUISA POR DENTISTA</option> */}
                        </Input>
                      </FormGroup>
                    </div>
                    <div>
                      <i id="loading_i_credenc_district"
                        style={{ display: 'none', width: 16, margin: '0 auto 8px auto'}}
                        className="fa fa-spinner fa-spin">
                        &nbsp;
                      </i>
                    </div>
                  </Col>
                </Row>

                {//PESQUISA POR ENDEREÇO
                  this.state.valueOption == 1 ? (
                <Row className="width_select">
                  <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <div id="col_i_credenc_district" style={{display: 'none'}}>
                      <div className="acrylic_dentist choose_city_dentist" style={{width:'100%'}}>
                        <FormGroup className="arrow_dentist" style={{margin:0, textAlign:'center'}}>
                          <Input
                            type="select" name="select" id="i_credenc_district"
                            onChange={this.findAccreditedNetwork.bind(this)}
                          >
                            <option value={-1}>SELECIONE SEU BAIRRO</option>
                            { 
                            this.state.listOfDistrict.map(item =>
                              <option key={item.Id} value={item.Id}>{item.Nome}</option>
                            )               
                          }
                          </Input>
                        </FormGroup>
                      </div>
                    </div>
                  </Col>
                </Row>
                  ) : ('')
                }

                {//PESQUISA POR ESPECIALIDADES
                  this.state.valueOption == 2 ? (
                <Row className="width_select">
                  <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    {
                      this.state.listSpecialties == 'loading' ? (
                    <div>
                      <i
                        style={{ width: 16, margin: '0 auto 8px auto'}}
                        className="fa fa-spinner fa-spin">
                        &nbsp;
                      </i>
                    </div>
                      ) : (
                    <div className="acrylic_dentist choose_city_dentist" style={{width:'100%'}}>
                      <FormGroup className="arrow_dentist" style={{margin:0, textAlign:'center'}}>
                        <Input
                          type="select" name="select" id="i_select_specialties"
                          onChange={this.findAccreditedNetwork.bind(this)}>
                          <option value={-1}>SELECIONE A ESPECIALIDADE</option>
                          { 
                            this.state.listSpecialties.map(item =>
                              <option key={item.Id} value={item.Id}>{item.Nome}</option>
                            )
                          }
                        </Input>
                      </FormGroup>
                    </div>
                      )
                    }
                  </Col>
                </Row>
                  ) : ('')
                }

                <div id="loading_i_credenc_result" style={{display: 'none'}}>
                  <i
                    style={{width: 16, margin: '0 auto 8px auto'}}
                    className="fa fa-spinner fa-spin">
                    &nbsp;
                  </i>
                </div>

                {this.state.accreditedNetwork == 'empty' ? (
                    <Alert className="alert_find">Não encontrado, entre em contado com a Dental Center através do número (83) 3041-4646</Alert>
                  ):('')
                }
              </Col>

              <Col style={{marginTop:10}} xs="12" sm="12" md="2" lg="2" xl="2">
                            <Row>
                                  <Col>
                                        {/* Imagens 3 */}
                                        <div className="accredited_network_img_3">  </div>        

                                  </Col>
                              </Row>
                              <Row>
                                    <Col>
                                            {/* Imagens 2 */}
                                        <div className="accredited_network_img_2">  </div>                     
                                    </Col>                                 
                            </Row>
               

                        </Col>                
            </Row>

          </div>


          {this.state.accreditedNetwork != null  ? (
            this.state.accreditedNetwork != 'empty' ? (
              this.state.accreditedNetwork.length != 0  ? (
          <div>
            {this.state.accreditedNetwork.length == 1 ? (
              <p className="results_1">{this.state.accreditedNetwork.length} DENTISTA ENCONTRADO!</p>
            ):(
              <p className="results_1">{this.state.accreditedNetwork.length} DENTISTAS ENCONTRADOS!</p>
            )}
            <p className="results_2">{this.state.accreditedNetwork[0].Municipio} - {this.state.accreditedNetwork[0].Uf}</p>
                  <Row>
                    <Col md='3'>
 
                    </Col>

                    <Col md='3' className='text-center'>

                   
                      <Link onClick={this.openPDF} >
                        <div  align="center" className="button_you_family">Visualizar PDF</div>
                      </Link>

                    </Col>
                    <Col md='3' className='text-center'>
                            <Link onClick={this.downloadPDF} >
                           <div className="button_you_family">Download PDF</div>
                           </Link>           
                    </Col>
                    <Col md='3'></Col>
                  </Row>
                  
                  <Row style={{padding:25}}>
                  {this.state.accreditedNetwork.map((item, index) =>
                    this.state.accreditedNetwork.length != index + 1 ? (
                      
                        <Col xs='12' sm='12' md='4' lg='4' xl='4'>

                          <Card style={{minHeight:400,marginBottom:20}}>
                            <CardHeader
                            title={'Dr. '+ item.Dentista}
                            subtitle={item.Especialidades}
                              actAsExpander={false}
                              showExpandableButton={false}
                              className='headerCard'
                            />
                            <CardText className='bodyCard' >
                            <p><FaRegBuilding className='icon_size' size={8} />{item.Clinica} - {item.NomeFantasia}</p>
                              {item.Telefone.indexOf('WhatsApp') != -1 ? (
                                <p><FaPhoneVolume className='icon_size' size={8} /> {item.Telefone.slice(0,-8)}  
                                 <img src={urlBase.client+'assets/images/WhatsApp.svg.png'} width="25" style={{marginRight: '2%'}}/>
                               </p>
                               ) : ( <p><FaPhoneVolume className='icon_size' size={8} /> {item.Telefone} </p> )
                               }

                           
                            <p><FaMapMarkerAlt className='icon_size' size={8} />{item.Endereco} - {item.Bairro}</p>
                            {item.Obs != "" ? (
                              <p className='obsCard'><FaRegEdit size={8} />{item.Obs}</p>
                            ) : ("")}
                            
                            <p style={{ textAlign: "left",position: 'absolute',bottom:36 }}>
                              <a style={{fontSize:'19px !important'}} id="modal_map" className="link_map" href="#" onClick={this.onOpenModalMap.bind(this, index)}>Ver mapa</a>
                            </p>
                            </CardText>
                          </Card>
                        </Col>                      
                    ) : (
                        /**Necessario para que o border bottom nao apareça na ultima linha */
                        
                          <Col xs='12' sm='12' md='4' lg='4' xl='4'>
                          <Card style={{ minHeight: 400, marginBottom: 20 }}>
                              <CardHeader
                              title={'Dr. '+item.Dentista}
                              subtitle={item.Especialidades}
                                actAsExpander={false}
                                showExpandableButton={false}
                                className='headerCard'
                              />
                              <CardText className='bodyCard' >
                              <p><FaRegBuilding size={8} />{item.Clinica}</p>
                              <p><FaPhoneVolume size={8} />{item.Telefone}</p>
                              <p><FaMapMarkerAlt size={8} />{item.Endereco} - {item.Bairro}</p>
                              {item.Obs != "" ? (
                                <p className='obsCard'><FaRegEdit size={8} />{item.Obs}</p>
                              ) : ("")}
                              <p style={{ textAlign: "left", position: 'absolute', bottom: 36 }}>
                                <a style={{ fontSize: 19 }} id="modal_map" className="link_map" href="#" onClick={this.onOpenModalMap.bind(this, index)}>Ver mapa</a>
                              </p>
                              </CardText>
                            </Card>
                          </Col>
                      )
                  )}        
                  </Row>              
          </div>
            ): ('')
            ):("")
          ):("")}


          {/************** Modal Mapa **********/}
          <Dialog
            open={openMap}
            onRequestClose={this.onCloseModalMap}
            title={
              <div>
              <i
                id="modal_wallet_slip_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.onCloseModalMap.bind(this)}
              >{''}</i>
            </div>
            }
            contentStyle={{maxHeight: '100%', minWidth: '80%', borderRadius: 20}}
          >
            <form onSubmit={this.findRouterMap.bind(this)}>
              <Row>
                <Col xs="12" sm="6" md="6" lg="6">
                  <p className="p_rede_cred">{this.state.dataClinic.Clinica}</p>
                  <p className="p_rede_cred3">{this.state.dataClinic.Endereco}</p>
                  <p className="p_rede_cred3">{this.state.dataClinic.Telefone}</p>
                  <p className="p_rede_cred3">{this.state.dataClinic.Bairro}, {this.state.dataClinic.Municipio} - {this.state.dataClinic.Uf}</p>
                </Col>
                <Col xs="12" sm="6" md="6" lg="6">
                  <FormGroup className="form_rede_cred">
                    <Label className="label_rede_cred">Informe seu endereço</Label>
                    <Input  className="ant-input input_form" 
                            type="text"
                            name="originClient"
                            id="originClient"
                            placeholder="NOME DA RUA/AVENIDA, BAIRRO, NÚMERO..."
                    />
                  </FormGroup>
                  <div className="button_contact_accre" onClick={this.findRouterMap.bind(this)}><span >ENCONTRAR ROTA</span></div>
                </Col>
              </Row>
            </form>
            <br/>
              <iframe src={this.state.googleUrl} className="iframeMap">
                &nbsp;
              </iframe>
            <hr />
          </Dialog>

  
        </Container>

        {/* Retirar a seção de contatos da página 
        <Contact />
        */}
        <Footer />

      </div>

    );
  }
}
export default AccreditedNetworkScreen;



/** WEBPACK FOOTER **
 ** ./src/components/AccreditedNetworkNew/AccreditedNetworkScreen.js
 **/